/* eslint-disable react/no-deprecated */
import React from 'react';
import { Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form/immutable';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { Line } from '@vds/lines';

import { Body } from '../../../common/Typography';
import Heading from '../../../common/Heading/head';
import TextLink from '../../../common/TextLink';
import SecurePin from './SecurePin';
import ShippingInfoEdit from './ShippingInfoEdit';
import Button from '../../../common/Button';
import { goToProcessStep } from '../../../../redirection';
import { eventDispatcher } from '../../../common/Tagging/index';
import {
  getFlowType,
  getSession,
  setSession,
  getAPPID,
  isMobile,
  renderElement,
  isDesktop,
  isLoggedIn as loggedIn,
  is5G,
  isTablet,
  isDesktopResolution,
  scrollToTop,
  isSequentialFlow,
  isShippingTabEnabled,
  isWHWP2,
} from '../../../common/Helpers/index';
import ContactInfoForm from './ContactInfoForm';
import { store } from '../../../../configureStore';
import { CTAProps, nonDesktopQuery, nonMobileQuery, StyledWrapper } from './shippingStyles';

import RadioButtonGroup from '../../../common/RadioButton';
import {
  NEW_SHIPPING_ADDRESS,
  SAME_5G_BILLING_ADDRESS,
  SAME_5G_SERVICE_ADDRESS,
  SAME_LTE_BILLING_ADDRESS,
  SAME_LTE_SERVICE_ADDRESS,
} from '../../../../pages/ShippingInfo/Constants';
import { mobileQuery } from '../../../common/styles';
import { getFullAddress } from '../../../common/ContactInfoUtils';

const AddressOptionCol = styled(Col)`
  .radioWrapper {
    span {
      font-weight: 400;
    }
    p {
      width: 297.92px;
    }
  }
  margin-top: ${isMobile() ? '24px' : '32px'};
`;
const AddressSubtext = styled(Body)`
  p {
    width: 297.92px;
  }
`;

class ShippingAdress extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shippingRadio: this.getSameAddressPreferedText(),
      showSecurePinModal: this.props.securePinData && this.props.shippingInfoState.showSecurePinModal,
      selectedSDDSlot: {},
      codeValid: false,
      disableButton: false,
      tabValue: false,
      shippingAddressCTAState: null,
      showShippingAddressCTAState: false,
      showISPUContactForm: false,
    };
  }

  componentDidMount() {
    window.addEventListener('load', this.handleShippingInfoLoad());
    // if (
    //   this.props.shippingInfoDetails?.lines?.[0].addressChangeRequired && this.props.shippingInfoDetails?.lines?.[0]?.addressChangeRsnCode
    //     ? this.props.shippingInfoDetails?.lines?.[0]?.addressChangeRsnCode === ''
    //     : true
    // ) {
    //   this.setState({ disableButton: true });
    //   // this.update();
    // }
    if (this.props.shippingInfoState.shippingAddressEdit) {
      this.setState({ shippingRadio: NEW_SHIPPING_ADDRESS });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.selectedShippingOption &&
      this.props.selectedShippingOption.shippingOptionId !== nextProps.selectedShippingOption.shippingOptionId
    ) {
      if (!this.props.shippingInfoDetails?.lines?.[0].addressChangeRequired) {
        if (nextProps.selectedShippingOption.shippingOptionId === 'SDD_SAMEDAY') {
          this.setState({ shippingRadio: SAME_5G_BILLING_ADDRESS, disableButton: true });
        } else {
          this.setState({ shippingRadio: this.getSameAddressPreferedText(), disableButton: false, selectedSDDSlot: '' });
        }
      }
      if (!this.props.shippingInfoDetails?.lines?.[0].addressChangeRequired) {
        this.setState({ shippingRadio: this.getSameAddressPreferedText() });
      }
    }
    if (this.props.shippingInfoState && nextProps?.securePinData?.preAuthorized === 'true') {
      this.setState({ codeValid: true, showSecurePinModal: false });
      this.CloseModel();
    }
    if (nextProps.securePinDataDeviceSucess?.fetchSMSEnabledDevices && nextProps?.securePinData?.preAuthorized === 'false') {
      this.setState({ showSecurePinModal: true });
      const obj = {
        name: 'securePinModal',
        selector: 'securePinModalID',
      };
      eventDispatcher('openView', obj);
    }
    if (this.props.shippingInfoState.updateShippingAdressflag !== nextProps.shippingInfoState.updateShippingAdressflag) {
      if (getAPPID() !== 'AAL' && this.props.isbillingInfoEdited) {
        this.redirection();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.showPickupInfoTab !== this.props?.showPickupInfoTab) {
      if (!this.props?.showPickupInfoTab && isShippingTabEnabled()) {
        this.setState({ showISPUContactForm: false });
        if (!this.props.shippingInfoDetails?.lines?.[0].addressChangeRequired) {
          this.setState({ shippingRadio: this.getSameAddressPreferedText() });
        }
      }
      if (this.props?.showPickupInfoTab && isShippingTabEnabled()) {
        if (!this.props.shippingInfoDetails?.lines?.[0].addressChangeRequired) {
          this.setState({ shippingRadio: this.getSameAddressPreferedText() });
        }
      }
    }
  }

  componentWillUnmount() {
    renderElement(null, 'ispuCTA');
    renderElement(null, 'shippingAddressCTA_2');
  }

  handleShippingInfoLoad = () => {
    const { shippingAddressCTAState, showShippingAddressCTAState } = this.state;
    const domNode = document?.getElementById('shippingAddressCTA_2');
    if (domNode && isDesktopResolution()) {
      renderElement(shippingAddressCTAState, 'shippingAddressCTA_2', showShippingAddressCTAState);
    }
  };

  redirection = () => {
    const { currentView, isCreditStatusAvailable, orderDetails, creditStatusLanded } = this.props;
    const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
    const changeToSelf = getSession('changeToSelf');
    let updateView;
    if (getAPPID() === 'NSE' && !isSequentialFlow() && isNoSlotsAvailable !== 'Y' && changeToSelf !== 'Y') {
      updateView = currentView.CreditCheck;
    } else if ((getAPPID() !== 'NSE' && isCreditStatusAvailable) || (isCreditStatusAvailable && !creditStatusLanded)) {
      updateView = currentView.CreditStatus;
    } else if (orderDetails.dueTodayAmount === '0.0' && isNoSlotsAvailable !== 'Y') {
      updateView = currentView.OrderReview;
    } else if (isNoSlotsAvailable === 'Y' || changeToSelf === 'Y') {
      if (
        (this.props.cartDetails &&
          this.props.cartDetails.shippingDetails &&
          this.props.cartDetails.shippingDetails[0] &&
          this.props.cartDetails.shippingDetails[0].shippingCost > 0) ||
        orderDetails.dueTodayAmount > 0
      ) {
        if (this.props.cartDetails && this.props.cartDetails.payments && this.props.cartDetails.payments.length === 0) {
          updateView = currentView.Payment;
        } else if (
          this.props.cartDetails &&
          this.props.cartDetails.payments &&
          this.props.cartDetails.payments.length > 0 &&
          this.props.cartDetails.payments[0] &&
          this.props.cartDetails.payments[0].paymentType
        ) {
          updateView = currentView.OrderReview;
        }
      } else {
        updateView = currentView.OrderReview;
      }
      // setSession('isNoSlotsAvailable', 'N');
    } else if (orderDetails.dueTodayAmount > 0) {
      if (this.props.cartDetails && this.props.cartDetails.payments && this.props.cartDetails.payments.length === 0) {
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: true });
        this.props.getPaymentOptions();
      } else if (
        this.props.cartDetails &&
        this.props.cartDetails.payments &&
        this.props.cartDetails.payments.length > 0 &&
        this.props.cartDetails.payments[0] &&
        this.props.cartDetails.payments[0].paymentType
      ) {
        updateView = currentView.OrderReview;
      }
    } else {
      updateView = currentView.OrderReview;
    }
    goToProcessStep(updateView, this.props.history);
  };

  redirect = (e) => {
    if (getSession('isNoSlotsAvailable') === 'Y' && this.props?.cartDetails?.orderDetailsView?.installType !== 'Professional SetUp') {
      setSession('isNoSlotsAvailable', 'N');
    }
    const changeToSelf = getSession('changeToSelf');
    // on SSD update contact Info have to make api call for same and If only Success take it next page
    if (e) e.preventDefault();
    const { currentView, isCreditStatusAvailable, orderDetails, creditStatusLanded } = this.props;
    if (getAPPID() !== 'AAL' && this.props.isbillingInfoEdited) {
      const data = {
        adress1: this.props.cartDetails?.cart5GAddress?.addressLine1,
        adress2: this.props.cartDetails?.cart5GAddress?.addressLine2,
        city: this.props.cartDetails?.cart5GAddress?.city,
        zipCode: this.props.cartDetails?.cart5GAddress?.zipCode,
        state: this.props.cartDetails?.cart5GAddress?.state,
        firstName: this.props.cartDetails && this.props.cartDetails.shippingDetails && this.props.cartDetails.shippingDetails[0]?.firstName,
        lastName: this.props.cartDetails && this.props.cartDetails.shippingDetails && this.props.cartDetails.shippingDetails[0]?.lastName,
        emailId: this.props.cartDetails && this.props.cartDetails.shippingDetails && this.props.cartDetails.shippingDetails[0]?.email,
        phoneNumber: this.props.cartDetails && this.props.cartDetails.shippingDetails && this.props.cartDetails.shippingDetails[0]?.cbrPhone,
        isFwaServiceAddress: false,
        // this.props.shippingDetails?.[0]?.cbrPhone,
      };

      let homePhoneAdded = false;
      const homePhoneResponse = this.props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
      if (homePhoneResponse.length > 0) {
        homePhoneAdded = true;
      }
      data.homePhoneAdded = homePhoneAdded;
      // calling shipping adress
      this.props.updateShippingAddress(data, homePhoneAdded);
    } else {
      const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
      let updateView;
      // let updateView = this.props.currentView.FiveG; NoSlotsAppointment
      if (getAPPID() === 'NSE' && !isSequentialFlow() && isNoSlotsAvailable !== 'Y' && changeToSelf !== 'Y') {
        updateView = currentView.CreditCheck;
      } else if ((getAPPID() !== 'NSE' && isCreditStatusAvailable) || (isCreditStatusAvailable && !creditStatusLanded)) {
        updateView = currentView.CreditStatus;
      } else if (orderDetails.dueTodayAmount === '0.0' && isNoSlotsAvailable !== 'Y') {
        updateView = currentView.OrderReview;
      } else if (isNoSlotsAvailable === 'Y' || changeToSelf === 'Y') {
        if (
          (this.props.cartDetails &&
            this.props.cartDetails.shippingDetails &&
            this.props.cartDetails.shippingDetails[0] &&
            this.props.cartDetails.shippingDetails[0].shippingCost > 0) ||
          orderDetails.dueTodayAmount > 0
        ) {
          if (this.props.cartDetails && this.props.cartDetails.payments && this.props.cartDetails.payments.length === 0) {
            updateView = currentView.Payment;
          } else if (this.props.cartDetails?.payments && this.props.cartDetails.payments.length && this.props.cartDetails.payments[0]?.paymentType) {
            updateView = currentView.OrderReview;
          }
        } else {
          updateView = currentView.OrderReview;
        }
        // setSession('isNoSlotsAvailable', 'N');
      } else if (orderDetails.dueTodayAmount > 0) {
        if (this.props.cartDetails && this.props.cartDetails.payments && this.props.cartDetails.payments.length === 0) {
          store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: true });
          this.props.getPaymentOptions();
        } else if (this.props.cartDetails?.payments && this.props.cartDetails.payments.length && this.props.cartDetails.payments[0]?.paymentType) {
          updateView = currentView.OrderReview;
        }
      } else {
        updateView = currentView.OrderReview;
      }
      goToProcessStep(updateView, this.props.history);
    }
  };

  modalChanged = (state) => {
    if (!state) {
      this.setState({
        shippingRadio: this.getSameAddressPreferedText(),
        // disableButton: false,
      });
    }
  };

  onClickEdit = () => {
    const { fetchSMSEnabledDevices } = this.props;
    const isLoggedIn = getAPPID() === 'AAL';
    if (isLoggedIn === true) {
      // this.setState({ showSecurePinModal: true, disableButton: true });
      fetchSMSEnabledDevices(this.props.cartDetails && this.props.cartDetails.cartHeader.fullAccountNumber);
    } else {
      this.setState({ showSecurePinModal: false, disableButton: true });
    }
    store.dispatch({ type: 'CLEAR_MARKET_DETAILS' });
  };

  CloseModel = () => {
    this.setState({ showSecurePinModal: false, disableButton: false });
  };

  onChangeHandler = (e) => {
    this.setState({ shippingRadio: e.target.value });
    if (e.target.value === NEW_SHIPPING_ADDRESS) {
      this.onClickEdit();
      this.props.shippingAddressEdited(true);
    } else {
      this.setState({ disableButton: false });
      store.dispatch({ type: 'ORDERUPDATE_ADRESS_SUUCESS' });
      this.props.shippingAddressEdited(false);
    }
  };

  getValues = (selectedSlot) => (
    <React.Fragment>
      <div>{selectedSlot.startTime}</div>
      <div>{selectedSlot.endTime}</div>
    </React.Fragment>
  );

  securePinSendSms = (data) => {
    // this.setState({MTN: data});
    this.props.securePinSendSms(data);
  };

  toggleContactInfoSDD = () => {
    this.setState({ selectedSDDSlot: {} });
  };

  cancelUpdated = () => {
    this.props.clearDevices();
    let disable = false;
    if (this.props.shippingInfoDetails?.lines?.[0].addressChangeRequired) {
      disable = true;
    }
    this.setState({
      shippingRadio: this.getSameAddressPreferedText(),
      disableButton: disable,
      showSecurePinModal: false,
    });
  };

  renderRadioValue = (item) => {
    if (item === NEW_SHIPPING_ADDRESS) {
      return NEW_SHIPPING_ADDRESS;
    }
    if (loggedIn()) return SAME_LTE_BILLING_ADDRESS;
    return SAME_LTE_SERVICE_ADDRESS;
  };

  toggleContactInfoISPU = () => {
    this.setState({ showISPUContactForm: true });
  };

  // used to enable or disable functionality in shipping info edit form.
  tabValueHandler = (value) => {
    this.setState({ tabValue: value });
  };

  showError = (message) => {
    this.setState(
      {
        disableButton: true,
      },
      () => {
        this.props.showErrorNotification(message);
      },
    );
    scrollToTop();
  };

  displayNewSHPAddressForm = () => {
    // debugger;
    if (getAPPID() === 'AAL') {
      const conditonAAL = this.state.shippingRadio === NEW_SHIPPING_ADDRESS && !this.state.showSecurePinModal && this.state.codeValid;
      return isShippingTabEnabled() ? !this.props?.showPickupInfoTab && conditonAAL : conditonAAL;
    }
    const conditionNSE = this.state.shippingRadio === NEW_SHIPPING_ADDRESS && !this.state.showSecurePinModal;
    return isShippingTabEnabled() ? !this.props?.showPickupInfoTab && conditionNSE : conditionNSE;
  };

  getSameAddressPreferedText = () => {
    const isExisingUser = loggedIn();
    if (is5G) {
      return isExisingUser ? SAME_5G_BILLING_ADDRESS : SAME_5G_SERVICE_ADDRESS;
    }
    return isExisingUser ? SAME_LTE_BILLING_ADDRESS : SAME_LTE_SERVICE_ADDRESS;
  };

  isBTARedirection = () => {
    if (
      this.props.shippingInfoState &&
      this.props.shippingInfoState.paymentSkipCall &&
      this.props.orderDetails.dueTodayAmount > 0 &&
      this.props.paymentInfoState
    ) {
      if (this.props.isBTAAvailable && this.props.isBTAAvailable.length > 0) {
        const isBTA = this.props.isBTAAvailable[0];
        const data = {
          isBTA,
        };
        store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: true });
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        this.props.confirmSubmit(data);
      } else if (this.props.otherPaymentOptions && this.props.otherPaymentOptions.length > 0) {
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        const updateView = this.props.currentView.Payment;
        goToProcessStep(updateView, this.props.history);
      }
    }
  };

  render() {
    // debugger;
    // console.log('GETAPP', getAPPID());
    // const { isEmailSuccess, accMainEmailVal, emailMaxAttempts } = this.props;
    const isAddressChangeRequired = this.props.shippingInfoDetails?.lines?.[0].addressChangeRequired;
    const addressChangeRsnCode = this.props.shippingInfoDetails?.lines?.[0].addressChangeRsnCode;
    let invalidUnitApartmentCase = false;
    if (
      isAddressChangeRequired &&
      window?.vzFlags?.isInvalidUnitNum &&
      addressChangeRsnCode &&
      addressChangeRsnCode !== '' &&
      (addressChangeRsnCode === '360401' || addressChangeRsnCode === '360402')
    ) {
      invalidUnitApartmentCase = true;
    }
    // console.log('invalidUnitApartmentCase', invalidUnitApartmentCase);
    const { shippingInvalidError, apiFailureError, fetchAutoFillAddressUnit } = this.props;
    if (
      this.props.shippingInfoDetails &&
      this.props.shippingInfoDetails?.lines &&
      this.props.shippingInfoDetails?.lines?.[0] &&
      this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions &&
      isEmpty(this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions)
    ) {
      this.setState({ disableButton: true });
    }
    if (shippingInvalidError || apiFailureError) {
      this.setState({
        disableButton: true,
      });
    }
    const flowType = getFlowType();
    const isLoggedIn = getAPPID() === 'AAL';
    const { shippingAddress, notifyMessage, shippingInfoState: { selectedValue } = {} } = this.props;
    const sameAdress = this.getSameAddressPreferedText();
    const shippingOptions = [];
    // const isSeqFlow = isSequentialFlow();
    this.isBTARedirection();

    if (this.props.isBTAEligible && this.props.paymentInfoState && this.props.paymentInfoState.confirmSubmitCall) {
      if (this.props.paymentInfoState && this.props.paymentInfoState.paymentSuccess && this.props.paymentInfoState.paymentSuccess.status === 200) {
        const updateView = this.props.currentView.OrderReview;
        goToProcessStep(updateView, this.props.history);
        store.dispatch({ type: 'REDIRECT_DONE', value: true });
        store.dispatch({ type: 'CONFIRM_SUBMIT_CALL', value: false });
        store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: false });
      } else if (this.props.paymentInfoState && this.props.paymentInfoState.errorDetails && this.props.paymentInfoState.errorDetails.showError) {
        store.dispatch({ type: 'CONFIRM_SUBMIT_CALL', value: false });
        store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: false });
        this.showError(
          this.props.paymentInfoState.errorDetails.notifyErrorMessage
            ? this.props.paymentInfoState.errorDetails.notifyErrorMessage
            : 'We are unable to process the request at this time. Please try after sometime',
        );
      }
    }

    if (isAddressChangeRequired && (addressChangeRsnCode ? addressChangeRsnCode === '' : !addressChangeRsnCode)) {
      shippingOptions.push(NEW_SHIPPING_ADDRESS);
    } else {
      shippingOptions.push(this.getSameAddressPreferedText(), NEW_SHIPPING_ADDRESS);
    }
    let serviceAddress = '';
    let addressLine1 = '';
    let addressLn2 = '';
    let city = '';
    let state = '';
    let zipcode = '';

    if (shippingAddress && shippingAddress[0] && shippingAddress[0].address) {
      serviceAddress = getFullAddress(shippingAddress[0].address);
    }

    if (isLoggedIn !== true) {
      addressLine1 = this.props.cartDetails?.cart5GAddress?.addressLine1;
      addressLn2 = this.props.cartDetails?.cart5GAddress?.addressLine2;
      city = this.props.cartDetails?.cart5GAddress?.city;
      state = this.props.cartDetails?.cart5GAddress?.state;
      zipcode = this.props.cartDetails?.cart5GAddress?.zipCode;
    } else if (shippingAddress && shippingAddress[0] && shippingAddress[0].address) {
      addressLine1 = shippingAddress?.[0].address?.addressLine1;
      addressLn2 = shippingAddress?.[0].address?.addressLine2;
      city = shippingAddress?.[0].address?.city;
      state = shippingAddress?.[0].address?.state;
      zipcode = shippingAddress?.[0].address?.zipCode;
    }

    const storeInfo = shippingAddress?.length && shippingAddress[0]?.storeinfo;
    const ispuSelected = storeInfo && selectedValue === 'ISPU';
    const isIspuSelectedFromStore =
      selectedValue && this.props.ISPUSelectedStoreFromModel && this.props.ISPUSelectedStoreFromModel?.id === selectedValue;
    const showPickupInfo = isShippingTabEnabled()
      ? this?.props?.showPickupInfoTab && !this.state.showISPUContactForm
      : ispuSelected && !this.state.showISPUContactForm;
    const showISPUCTA = isShippingTabEnabled()
      ? !this.state.showISPUContactForm && this.props.showPickupInfoTab
      : ispuSelected && !this.state.showISPUContactForm && storeInfo;

    const showShippingAddressCTA = isShippingTabEnabled()
      ? !this.props.showPickupInfoTab && this.state.shippingRadio !== NEW_SHIPPING_ADDRESS
      : invalidUnitApartmentCase
        ? false
        : this.state.shippingRadio !== NEW_SHIPPING_ADDRESS &&
          Object.keys(this.state.selectedSDDSlot).length === 0 &&
          (!shippingAddress?.length || !storeInfo);
    const ispuCTA = (
      <>
        {showISPUCTA && (
          <StyledWrapper styles={`${isTablet() ? 'margin-top: 20px;' : ''} ${mobileQuery('margin-top: 20px;')}`}>
            <Button
              className="ispuCTA"
              primary
              onClick={(e) => this.redirect(e)}
              {...CTAProps}
              data-analyticstrack={`{"type": "data",  "name": "5G-ShippingOptions", "data": {"txn": {"displayshippingoption": ${this.props.selectedShippingOption?.shortDescription}}}}`}
            >
              Continue
            </Button>
          </StyledWrapper>
        )}
      </>
    );

    const shippingAddressCTA = (
      <>
        {showShippingAddressCTA && (
          <StyledWrapper styles={`margin-top: 20px; ${nonDesktopQuery('margin-top: 63px;')}`}>
            <Button
              className={`shippingAddressCTA ${storeInfo ? 'hideContentShipping' : ''}`}
              primary
              onClick={(e) => this.redirect(e)}
              disabled={storeInfo ? false : this.state.disableButton}
              data-track="true"
              width={isTablet() && !isDesktopResolution() ? '383px' : '100%'}
              data-analyticstrack={`{"type": "data",  "name": "5G-ShippingOptions", "data": {"txn": {"displayshippingoption": ${this.props.selectedShippingOption?.shortDescription}}}}`}
            >
              {isWHWP2() ? 'Review order' : 'Continue'}
            </Button>
          </StyledWrapper>
        )}
      </>
    );
    if (!this.state.shippingAddressCTAState) {
      this.setState({ shippingAddressCTAState: shippingAddressCTA, showShippingAddressCTAState: showShippingAddressCTA });
    }

    return (
      <>
        <React.Fragment>
          <Body bold>
            {ispuSelected || this.props?.showPickupInfoTab ? null : (
              <div className="shippingAddressWrapper">{this.props.shippingAddressText ? this.props.shippingAddressText : 'Shipping address'}</div>
            )}
          </Body>
          {(isShippingTabEnabled() ? !this.props?.showPickupInfoTab : !ispuSelected) && (
            <fieldset aria-label="Shipping address" className="noPad noBorder">
              <Row>
                <AddressOptionCol>
                  <RadioButtonGroup
                    value={this.state.shippingRadio}
                    onChange={this.onChangeHandler}
                    error={false}
                    data={shippingOptions.map((option) => ({
                      label: flowType && flowType === 'LTE' ? this.renderRadioValue(option) : option,
                      children:
                        option === sameAdress ? (
                          <div style={{ width: isDesktop() ? '890px' : 'auto' }}>
                            <AddressSubtext size="medium" bold>
                              {[addressLine1, addressLn2, city, state, zipcode].filter((text) => text).join(', ')}
                            </AddressSubtext>
                            {invalidUnitApartmentCase && this.state.shippingRadio !== NEW_SHIPPING_ADDRESS && (
                              <ShippingInfoEdit
                                // shippingAddressEdit
                                {...this.props}
                                invalidUnitApartmentCase={invalidUnitApartmentCase}
                                tabValue={this.state.tabValue}
                                tabValueHandler={(value) => {
                                  this.tabValueHandler(value);
                                }}
                                updateShippingAdressflag={this.props.shippingInfoState.updateShippingAdressflag}
                                shippingDetails={this.props.cartDetails.shippingDetails}
                                notifyMessage={notifyMessage}
                                fetchAutoFillAddress={this.props.fetchAutoFillAddress}
                                addressList={this.props.addressList}
                                shippingAddressErrorMessage={this.props.shippingAddressErrorMessage}
                                lvShippingAddressTitle={this.props?.lvShippingAddressTitle}
                                lvShippingAddressSubtitle={this.props?.lvShippingAddressSubtitle}
                                isEmptyAddress={this.props.isEmptyAddress}
                                redirection={this.redirection}
                                isBTARedirection={this.isBTARedirection}
                                fetchAutoFillAddressUnit={fetchAutoFillAddressUnit}
                              />
                            )}
                          </div>
                        ) : undefined,
                      ariaLabel: flowType && flowType === 'LTE' ? this.renderRadioValue(option) : option,
                      value: option,
                    }))}
                    // defaultValue={sameAdress}
                    className="addressOptions"
                  />
                </AddressOptionCol>
              </Row>
            </fieldset>
          )}
          {Object.keys(this.state.selectedSDDSlot).length !== 0 && (
            <div className="contains-PII" data-cs-mask>
              <React.Fragment>
                <h3>Same-day Shipping</h3>
                <div>{serviceAddress}</div>
                <Row>
                  <Col xs={6}>
                    {this.state.selectedSDDSlot.startTime}-{this.state.selectedSDDSlot.endTime}
                  </Col>
                  <Col xs={1} className="marginTop6 noRightPad">
                    <Button size="large" analyticstrack="5G-editContactInfo" onClick={this.toggleContactInfoSDD} data-track>
                      Edit
                    </Button>
                  </Col>
                </Row>
                <ContactInfoForm {...this.props} />
              </React.Fragment>
            </div>
          )}
          {showPickupInfo ? (
            <>
              <Row middle="xs" className="marginTop20">
                <Col xs={isMobile() ? 9 : 10} lg={5}>
                  <Heading heading="Pickup contact information" size="24" width={isMobile ? '341px' : ''} />

                  <StyledWrapper styles={`margin-top: 4px; ${nonMobileQuery('margin-top: 8px;')}`}>
                    <Body color="#6F7171" primitive="p" size="small">
                      {this.props.cartDetails?.primaryUserInfo?.firstName} {this.props.cartDetails?.primaryUserInfo?.lastName}
                    </Body>
                    <Body color="#6F7171" primitive="p" size="small">
                      {shippingAddress && shippingAddress[0]?.address?.emailId}
                    </Body>
                    <Body color="#6F7171" primitive="p" size="small">
                      {shippingAddress && shippingAddress[0]?.address?.phoneNumber}
                    </Body>
                  </StyledWrapper>
                </Col>
                <Col xs={1}>
                  <TextLink
                    disabled={!storeInfo}
                    size="large"
                    analyticstrack="5G-editContactInfo"
                    type="standAlone"
                    onClick={this.toggleContactInfoISPU}
                    data-track
                  >
                    Edit
                  </TextLink>
                </Col>
              </Row>
              <StyledWrapper styles="margin: 33px 0px 23px;">
                <Line type="secondary" surface="light" />
              </StyledWrapper>
              <Row>
                <Col style={{ paddingTop: '10px' }} xs={12} lg={6}>
                  <Heading heading="A couple of important things" size="24" width={isMobile ? '341px' : ''} />
                  <StyledWrapper styles="margin-top: 8px" />
                  <Body color="#6F7171" primitive="p" size="medium">
                    {this.props.cartDetails?.primaryUserInfo?.firstName} {this.props.cartDetails?.primaryUserInfo?.lastName} must pickup the order.
                    Bring the government-issued ID and the card used to make the purchase
                  </Body>
                </Col>
              </Row>
            </>
          ) : null}

          {isShippingTabEnabled()
            ? this.props?.showPickupInfoTab &&
              this.state.showISPUContactForm &&
              (ispuSelected || isIspuSelectedFromStore) && <ContactInfoForm {...this.props} />
            : this.state.showISPUContactForm && ispuSelected && <ContactInfoForm {...this.props} />}
          {/* {this.props?.showPickupInfoTab && this.state.showISPUContactForm ? (
            <ContactInfoForm {...this.props} />
          ) : (
            this.state.showISPUContactForm && ispuSelected && <ContactInfoForm {...this.props} />
          )} */}

          {isDesktop() ? renderElement(ispuCTA, 'ispuCTA', showISPUCTA) : ispuCTA}
          {this.state.shippingRadio === NEW_SHIPPING_ADDRESS && this.state.showSecurePinModal && (
            <SecurePin
              {...this.props}
              CloseModel={this.CloseModel}
              securePinDataDeviceSucess={this.props.shippingInfoState}
              devices={this.props.securePinDataDeviceSucess.fetchSMSEnabledDevices}
              cancelUpdated={this.cancelUpdated}
              modalChanged={this.modalChanged}
              // securePinSendSms={this.props.securePinSendSMS}
              // shippingAddressProps={this.props}
            />
          )}
          {this.displayNewSHPAddressForm() && (
            <ShippingInfoEdit
              {...this.props}
              tabValue={this.state.tabValue}
              tabValueHandler={(value) => {
                this.tabValueHandler(value);
              }}
              updateShippingAdressflag={this.props.shippingInfoState.updateShippingAdressflag}
              shippingDetails={this.props.cartDetails.shippingDetails}
              notifyMessage={notifyMessage}
              fetchAutoFillAddress={this.props.fetchAutoFillAddress}
              addressList={this.props.addressList}
              shippingAddressErrorMessage={this.props.shippingAddressErrorMessage}
              lvShippingAddressTitle={this.props?.lvShippingAddressTitle}
              lvShippingAddressSubtitle={this.props?.lvShippingAddressSubtitle}
              isEmptyAddress={this.props.isEmptyAddress}
              redirection={this.redirection}
              isBTARedirection={this.isBTARedirection}
              fetchAutoFillAddressUnit={fetchAutoFillAddressUnit}
            />
          )}
          {isDesktopResolution() ? renderElement(shippingAddressCTA, 'shippingAddressCTA_2', showShippingAddressCTA) : shippingAddressCTA}
        </React.Fragment>
      </>
    );
  }
}

export default reduxForm({})(ShippingAdress);

ShippingAdress.propTypes = {
  selectedShippingOption: PropTypes.object,
  shippingAddress: PropTypes.array,
  securePinSendSms: PropTypes.func,
  securePinData: PropTypes.object,
  securePinDataDeviceSucess: PropTypes.object,
  fetchSMSEnabledDevices: PropTypes.func,
  cartDetails: PropTypes.object,
  shippingRadio: PropTypes.string,
  sddSlots: PropTypes.object,
  buildShippingOptionsInput: PropTypes.func,
  securePinValidateAuthCode: PropTypes.func,
  getSmsSuccess: PropTypes.func,
  securePinSendSMS: PropTypes.func,
  currentView: PropTypes.object,
  orderDetails: PropTypes.object,
  history: PropTypes.object,
  updateShippingAddress: PropTypes.func,
  shippingInfoDetails: PropTypes.object,
  shippingInfoState: PropTypes.object,
  getZipDetailsFromApi: PropTypes.func,
  marketDetails: PropTypes.object,
  clearDevices: PropTypes.func,
  contactInfoUpdte: PropTypes.func,
  toggleContactInfo: PropTypes.func,
  shippingAddressText: PropTypes.string,
  isCreditStatusAvailable: PropTypes.bool,
  creditStatusLanded: PropTypes.bool,
  notifyMessage: PropTypes.string,
  getPaymentOptions: PropTypes.func,
  paymentInfoState: PropTypes.any,
  isBTAAvailable: PropTypes.any,
  confirmSubmit: PropTypes.any,
  isBTAEligible: PropTypes.any,
  otherPaymentOptions: PropTypes.any,
  isbillingInfoEdited: PropTypes.bool,
  paymentZipcodeError: PropTypes.string,
  showErrorNotification: PropTypes.any,
  updateValidateOTPResponse: PropTypes.string,
  emailVaildationShippingAPI: PropTypes.func,
  accMainEmailShippingVerify: PropTypes.func,
  setEmailValidationdata: PropTypes.func,
  fetchAutoFillAddress: PropTypes.func,
  addressList: PropTypes.array,
  shippingAddressErrorMessage: PropTypes.string,
  lvShippingAddressTitle: PropTypes.string,
  lvShippingAddressSubtitle: PropTypes.string,
  isEmptyAddress: PropTypes.string,
  shipping_info_email_legal_new: PropTypes.string,
  apiFailureError: PropTypes.any,
  shippingInvalidError: PropTypes.any,
  getCreditCheckOnClick: PropTypes.func,
  creditReviewSuccessResponse: PropTypes.object,
  fetchAutoFillAddressUnit: PropTypes.func.isRequired,
  shippingAddressEdited: PropTypes.func,
  showPickupInfoTab: PropTypes.bool,
  ISPUSelectedStoreFromModel: PropTypes.any,
};
